import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { PqrReceivedThroughActionsProps } from './props';
import { usePqrReceivedThroughListActions } from './hook';

export const PqrReceivedThroughListActions = ({
    id,
}: PqrReceivedThroughActionsProps) => {
    const { handleEdit } = usePqrReceivedThroughListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
